import { render, staticRenderFns } from "./SamplingSites.vue?vue&type=template&id=4ca7a8e0&scoped=true&"
import script from "./SamplingSites.vue?vue&type=script&lang=ts&"
export * from "./SamplingSites.vue?vue&type=script&lang=ts&"
import style0 from "./SamplingSites.vue?vue&type=style&index=0&id=4ca7a8e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7a8e0",
  null
  
)

export default component.exports